import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import CSSTransition from 'react-transition-group/CSSTransition';
import { scrollTo } from 'lib/helpers';
import { Button } from 'components/core/Button';
import { Text } from 'components/core/Text';
import { UpArrow } from 'components/svg';
import { on, off } from 'utils/dom/dom';
import './backToTop.scss';

function onClick() {
	scrollTo(0);
}



/**
 * Fixed to the bottom right of the page and appears after the user has scrolled a given distance
 */
export class BackToTop extends PureComponent {
	constructor(props) {
		super(props);
		this.update = this.update.bind(this);
	}

	state = {
		showing: false
	}

	componentDidMount() {
		on(['resize', 'scroll'], this.update);
		setTimeout(this.update, 100);
	}

	componentWillUnmount() {
		off(['resize', 'scroll'], this.update);
	}

	update() {
		const showing = window.pageYOffset >= this.props.offsetDistance;
		if (this.state.showing !== showing) {
			this.setState({ showing });
		}
	}

	render() {
		const { showing } = this.state;
		return (
			<TransitionGroup>
				{showing &&
					<CSSTransition
						timeout={500}
						classNames="transition-fade-in"
					>
						<Button
							primary={false}
							className="back-to-top"
							onClick={onClick}
						>
							<UpArrow />
							<Text family="rounded">
								TOP
							</Text>
						</Button>
					</CSSTransition>
				}
			</TransitionGroup>
		);
	}
}

BackToTop.propTypes = {
	/** Distance from top of the page before the button appears */
	offsetDistance: PropTypes.number
};

BackToTop.defaultProps = {
	offsetDistance: 300
};

export default BackToTop;
